import * as checkActions from '@src/state/checks/actions'
import * as documentActions from '@src/state/document/actions'
import * as sessionActions from '@src/state/session/actions'
import { GlobalActions } from '@src/types/actions'
import { Check, RUNNING } from '@src/types/checks'
import { LOCATION_CHANGE } from 'connected-react-router'
import { ActionType, getType } from 'typesafe-actions'
import { resetState } from '../actions'

export type CheckActions =
  | ActionType<typeof checkActions | typeof documentActions | typeof sessionActions>
  | { type: typeof LOCATION_CHANGE }

export interface CheckState {
  readonly [name: string]: Check
}

const initialState: CheckState = {}

const checkReducer = (
  state: CheckState = initialState,
  action: CheckActions | GlobalActions
) => {
  switch (action.type) {
    case getType(checkActions.clearChecks):
    case getType(documentActions.handleDocumentCreate):
    case getType(checkActions.runChecks): {
      return initialState
    }
    case getType(checkActions.setCheck): {
      return {
        ...state,
        [action.payload.type]: {
          count: action.payload.count,
          finished: true,
          status: action.payload.status,
          type: action.payload.type,
          overallMatchPercentage: action.payload.overallMatchPercentage,
        },
      }
    }
    case getType(checkActions.checkStart): {
      // look to see if this check has already finished by pusher returning before the dispatch of this action
      if (state[action.payload.type]?.finished) {
        return state
      }

      return {
        ...state,
        [action.payload.type]: {
          finished: false,
          status: RUNNING,
        },
      }
    }
    case getType(checkActions.checkResults.failure): {
      return {
        ...state,
        [action.payload.type]: {
          ...action.payload,
          count: 0,
        },
      }
    }
    case getType(sessionActions.loadFromLocalStorage): {
      return {
        ...action.payload.checks,
      }
    }
    case getType(resetState): {
      return initialState
    }
    default: {
      return state
    }
  }
}

export default checkReducer



// WEBPACK FOOTER //
// ./src/state/checks/reducer.ts